<template>
  <b-container fluid>
    <h1>CloudDrive</h1>

    <div v-if="isBucketListLoaded"> 
      <label id="lbl" for="selectFolder" style="font-weight:600;">Please select a bucket (i.e. folder) to work with:</label>
      <b-form-select id="selectFolder" v-model="selected">
        <option disabled selected value> Please Select a Bucket</option>
        <option v-for="(item, index) in buckets" :key="index" :value="item">
          {{item.businessName}}
        </option>
      </b-form-select>
    </div>
    <div v-else>
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div>Loading bucket list...</div>
    </div>

    <b-alert show variant="danger" v-if="isBucketListLoaded && buckets.length === 0" 
      style="margin-top:12px;">
      You currently are not authorized to view any buckets.
    </b-alert>
    
    <div v-if="selected.bucketName">
      <div class="mt-3" v-if="permissions.download && permissions.list">
        <b-row>
          <b-col cols="9">
            <h2>{{ selected.businessName }}</h2>
          </b-col>
          <b-col cols="3" v-if="sendEmails">
            <b-form-checkbox v-model="permissions.sendEmails" name="email-input" switch v-if="permissions.list" @change="setEmails($event)">
              Bucket File Upload Notifications
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>

          <b-alert show variant="warning" v-if="selected.contentType === '02'">
            Audio Transcriptions are limited to 4 hours (~2GB).  Supported file types include:
            WAV, MP3, MP4 and FLAC.
          </b-alert>
          
          <dropzone v-if="selected.bucketName && permissions.upload" style="margin-top:20px;"
            :bucketName="selected.bucketName"
            :bucketId="selected.id"
            :selectedFolder="selectedFolderNode.data.prefix">
          </dropzone>

          <b-tabs content-class="mt-3" style="margin-top:20px;" lazy>
            <b-tab title="Bucket Files" active>
              <fileList
                :bucketName="selected.bucketName"
                :bucketId="selected.id"
                :bucketType="selected.contentType">
              </fileList>
            </b-tab>
            <b-tab title="Audio Transcribe Jobs"
              v-if="selected.contentType === '02'"
              @click="eventBus.$emit('job-refresh')">
              <AudioTranscribeJobs 
                :bucketName="selected.bucketName"
                :bucketId="selected.id"
                :bucketType="selected.contentType">
              </AudioTranscribeJobs>
            </b-tab>
          </b-tabs>
    </div>
      
  </b-container>  
</template>

<script>
import Dropzone from '@/components/Dropzone'
import FileList from '@/components/FileList'
import {eventBus} from "@/main";
import axios from 'axios';
import axiosRetry from 'axios-retry';
import config from '@/config'
import AudioTranscribeJobs from '@/components/AudioTranscribeJobs'

axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

export default {
  name: 'app',
  components: {
    Dropzone,
    FileList,
    AudioTranscribeJobs
  },

  data: () => ({
    isBusy: false,
    isBucketListLoaded: false,
    buckets: [],
    selected: {},
    selectedFolderNode: {
      data: {
        prefix: ""
      }
    },
    permissions: {},
    sendEmails: config.SEND_EMAILS
  }),

  created () {

     eventBus.$on('folder-selected', (_folderNode) => {
      this.selectedFolderNode = _folderNode
        this.initialize()
    })

    eventBus.$on('all-upload-complete', (_bucketId, _names, _errors) => {
      let payload = {
        bucketId: _bucketId,
        fileNames: _names,
        errors: _errors,
        operation: 'upload',
      }
      axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'sendBucketEmails', payload)
        .catch((err) => {
          console.log(err)
        })
      axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'event', payload)
        .catch((err) => {
          console.log(err)
        })
    })

    this.initialize()
  },

  watch: {
    selected: {
      deep: true, 
      handler() {
        this.fetchPermissions()
        eventBus.$emit('upload-complete', this.selected.bucketName)
      }
    }
  },

  methods: {
    initialize() {
      this.fetchMyBuckets()
    },

    fetchMyBuckets() {
      this.isBusy = true
      this.isBucketListLoaded = false
      axios.get(config.CLOUDDRIVE_API_ENDPOINT + 'buckets')
            .then(response => {
                this.buckets = response.data
                this.isBusy = false
                this.isBucketListLoaded = true
              })
    },

    fetchPermissions() {
      let payload = {
        bucketName: this.selected.id,
      }
      
      axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'getBucketPermissions', payload)
        .then((res) => {
            this.permissions = res.data
        })
        .catch((err) => {
            console.log(err)            
        })
    },
    setEmails(evt) {
      axios.post(`${config.CLOUDDRIVE_API_ENDPOINT}bucketuser/email/` + evt, this.permissions)
    }
  }
}
</script>

